import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">Sanjib Roy</h3>
            <p className="footer-tagline">
              Performance Marketing Consultant & Growth Marketing Consultant
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <nav className="footer-nav">
              <button onClick={() => scrollToSection('about')} className="footer-link">About</button>
              <button onClick={() => scrollToSection('services')} className="footer-link">Services</button>
              <button onClick={() => scrollToSection('experience')} className="footer-link">Experience</button>
              <button onClick={() => scrollToSection('faq')} className="footer-link">FAQ</button>
              <button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Connect</h4>
            <div className="footer-social">
              <a 
                href="https://www.linkedin.com/in/sanjibroy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="mailto:roy.san007@gmail.com" 
                className="social-link"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Sanjib Roy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
